import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { io } from 'socket.io-client'
import { updateSocket, updateUserId } from '../slices/userSlice'
import Loading from './Loading'


export default function Home() {

    let dispatch = useDispatch()
    let { socket, userId } = useSelector(state => state.userSlice)

    useEffect(() => {
        // let socket = io.connect('http://localhost:8000')
        let socket = io.connect('https://tictactoe-frs.herokuapp.com')
        socket.on('connect', () => {
            dispatch(updateSocket({ skt: socket }))
            dispatch(updateUserId(socket.id))
        })
        // eslint-disable-next-line
    }, [])

    return (
        <div className="Home">
            {(userId === null || socket === null) ?
                (<Loading />)
                :
                (<div className="btn-div">
                    <Link to="/play/single-player-game" className="link"><button className="home-button">Single Player</button></Link>
                    <Link to="/play/multi-player-game" className="link"><button className="home-button">Multi Player</button></Link>
                </div>)
            }
        </div>
    )
}
